export default __webpack_public_path__ + "static/media/lock.6857c469.svg";